<template>
  <div class="contentbox" v-if="webConfig">
    <div class="header">
      <div class="headerbox">
        <img :src="`${IP_TEST}/uploads/${webConfig.logopic}`" alt="" @click="$router.push('/')">
        <a href="/inquery">继续查询</a>
      </div>
      
    </div>
    <div class="show" v-if="showInfo">
      <div class="toplogo">
        <h1>查询结果</h1>
      </div>
        <table  class="personInfo" >
          <tr class="theader">
            <th colspan="5">
              人员基本信息
            </th>
          </tr>
          <tr>
            <td v-if="!(showInfo.certtypename=='专业技术人才职业技能培训证书'||showInfo.certtypename=='职业技能培训合格证书'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书')" rowspan="4" style="padding:15px;width:200px">
              <img :src="`/uploads/xlsfile/usepic/${showInfo.picsrc}`" alt="">
            </td>
            <td>姓名：</td>
            <td>{{ showInfo.name }}</td>
            <td>性别：</td>
            <td>{{ showInfo.sex }}</td>
          </tr>
          <tr>
            <td>证件类型：</td>
            <td>{{ showInfo.cardtype }}</td>
            <td>身份证号：</td>
            <td>{{ showInfo.cardid }}</td>
          </tr>
          <tr>
            <td>出生日期：</td>
            <td>{{ showInfo.birthday }}</td>
            <td>学历：</td>
            <td>{{ showInfo.education }}</td>
          </tr>
          <tr>
            <td>工作单位：</td>
            <td colspan="3">{{ showInfo.danwei }}</td>
          </tr>
        </table>
        
        <table  class="personInfo" v-if="showInfo.certtypename=='专业技术人才职业技能培训证书'||showInfo.certtypename=='职业技能培训合格证书'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书'">
          <tr class="theader">
            <th colspan="4">
              证书基本信息
            </th>
          </tr>
          <tr>
            <td>证书编号：</td>
            <td colspan="3">{{ showInfo.code }}</td>
          </tr>
          <tr>
            <td>申报专业：</td>
            <td colspan="3">{{ showInfo.certname }}</td>
          </tr>
          <tr>
            <td>证书类别：</td>
            <td colspan="3">{{ showInfo.certtypename }}</td>
          </tr>
          <tr>
            <td>考试成绩：</td>
            <td>{{ showInfo.certscore }}</td>
            <td>申报级别：</td>
            <td>{{ showInfo.certlevel }}</td>
          </tr>
          <tr>
            <td>发证日期：</td>
            <td colspan="3">{{ showInfo.certdate }}</td>
            <!-- <td>有效日期：</td>
            <td>{{ formatExcelData(showInfo.valieddate) }}</td> -->
          </tr>
          <tr>
            <td>证书颁发机构：</td>
            <td colspan="3">{{ showInfo.regauth }}</td>
          </tr>
          <tr>
            <td>发证机构网址：</td>
            <td colspan="3">{{ showInfo.regurl }}</td>
          </tr>
        </table>
        <table  class="personInfo" v-else>
          <tr class="theader">
            <th colspan="4">
              证书基本信息
            </th>
          </tr>
          <tr>
            <td>证书编号：</td>
            <td>{{ showInfo.code }}</td>
            <td>证书类别：</td>
            <td>{{ showInfo.certtypename }}</td>
          </tr>
          <tr>
            <td>申报专业：</td>
            <td >{{ showInfo.certname }}</td>
            <td>专业方向：</td>
            <td >{{ showInfo.majorfield }}</td>
          </tr>
          <tr>
            <td>申报级别：</td>
            <td>{{ showInfo.certlevel }}</td>
            <td>考试成绩：</td>
            <td>{{ showInfo.certscore }}</td>
          </tr>
          <tr>
           
            <td>发证日期：</td>
            <td colspan="3">{{ showInfo.certdate }}</td>
            <!-- <td>有效日期：</td>
            <td>{{ formatExcelData(showInfo.valieddate) }}</td> -->
          </tr>
          <tr>
            <td>证书颁发机构：</td>
            <td colspan="3">{{ showInfo.regauth }}</td>
          </tr>
          <tr>
            <td>发证机构网址：</td>
            <td colspan="3">{{ showInfo.regurl }}</td>
          </tr>
        </table>
        <table  class="personInfo" >
          <tr class="theader">
            <th colspan="4">
              继续教育记录
            </th>
          </tr>
          <div v-for="item in  pagenum" :key="item">
            <tr class="title">
              <td>{{ arrSprtQys[item-1]? arrSprtQys[item-1].title:''}}</td>
              <td>{{ arrSprtQys[item]? arrSprtQys[item].title:''}}</td>
              <td>{{ arrSprtQys[item+1]? arrSprtQys[item+1].title:''}}</td>
              <td>{{ arrSprtQys[item+2]? arrSprtQys[item+2].title:''}}</td>
            </tr>
            <tr class="date">
              <td>{{ arrSprtQys[item-1]? arrSprtQys[item-1].date:''}}</td>
              <td>{{ arrSprtQys[item]? arrSprtQys[item].date:''}}</td>
              <td>{{ arrSprtQys[item+1]? arrSprtQys[item+1].date:''}}</td>
              <td>{{ arrSprtQys[item+2]? arrSprtQys[item+2].date:''}}</td>
              
            </tr>
          </div>
          
        </table>
    </div>
  </div>

</template>

<script>
/**
 * 个人证书查询系统模版
 */
import { IP_TEST } from '@/config';
import QRCode from "qrcodejs2";
import { getFindAll } from '../../request/get'
export default {
  name: "ShowGr",
  data() {
    return {
      IP_TEST,
      webConfig:null,
      arrSprtQys:[],
      pagenum:1
    }
  },
  computed: {
  },
  created(){
    this.getFindAll();
    
  },
  props: {
    showInfo: Object
  },
  mounted() {
    if(this.showInfo.nianjian)
    {
      let arrtmpsprts=this.showInfo.nianjian.split("##");
      for(let i = 0; i < arrtmpsprts.length;i++) {
        this.arrSprtQys[i]={
          title:arrtmpsprts[i].split("||")[0],
          date:arrtmpsprts[i].split("||")[1],
        }
      }
      this.pagenum = Math.ceil( this.arrSprtQys.length/4);
      if(this.pagenum===0)this.pagenum=1;
    }
	// this.creatQrCode(this.showInfo.cardid,this.showInfo.name,this.showInfo.bzcode,this.showInfo.certname);
  },
  methods: {
    async getFindAll() {
      let result = await getFindAll();
      result = result.data[0] || null;
      this.webConfig = result;
      this.$store.dispatch("SET_WEBCONFIG", result);
    },
    goHome() {
      this.$router.push("/");
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
  },
   formatExcel(value) {
      if (!value) {
          return "";
      } else {
          if (typeof value == "string") {
              return value.trim();
          } else {
              return value.toString().trim();
          }
      }
  },
	creatQrCode(code, name,bzcode,certname) {
		if(!bzcode)bzcode='';
		if(!code)code='';
		if(!name)name='';
		if(!certname)certname='';
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: encodeURI(
          `${this.IP_TEST}/showM?cname=${name}&ccode=${code}&bzcode=${bzcode}&certname=${certname}&selectid=1`
        ), // 需要转换为二维码的内容
        width: 117,
        height: 117,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
  }
};
</script>
<style scoped>
.contentbox{
  background-image: url(/static/img/result_bg.png);
  height: 1300px;
  padding-bottom: 150px;
}
.contentbox .header{
  height: 45px;
    background: #094DA6;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    padding: 30px 0 30px 0;
}
.contentbox .headerbox{
  width: 1300px;
  margin: auto;
  
}
.headerbox img{
  width:608px;
  /* height:49px; */
}
.contentbox .show{
  width: 1300px;
  margin: auto;
  margin-top: 50px;
  background: rgba(255,255,255,0.95);
  border-radius: 16px 16px 16px 16px;
  min-height: 965px;
    padding-bottom: 50px;
}
.toplogo{
  background-image: url(/static/img/toplogo.png);
  width: 592px;
  height: 55px;
  margin: auto;
  position: relative;
  top:7px;
  padding-top: 67px;
}
.toplogo h1{
  font-size: 24px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 28px;
  text-align: center;
  letter-spacing: 3px;
}
.personInfo{
  width:1000px;
  margin: auto;
  margin-top: 34px;
  font-size: 24px;
  border-collapse:collapse;
  border-spacing:0;
  border-left:1px solid #999999;;
  border-top:1px solid #999999;;
}
.personInfo td{
  border-right:1px solid #999999;;
  border-bottom:1px solid #999999;;
  /* padding:5px 15px; */
  height: 54px;
  line-height: 54px;
  padding-left: 22px;
  font-size: 21px;
}
.personInfo th{
  background: #DDEBFC;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  height: 62px;
  line-height: 62px;
  border: 1px solid #0157C6;
}
.personInfo tr td:nth-child(2n-1){
  width: 180px;
}
.personInfo tr td:nth-child(2n){
  width: 290px;
}
.theader{
  text-align: center;
  font-weight: bold;
  color: #0157C6;
  line-height: 28px;
}
.headerbox a{
  float: right;
    font-size: 18px;
    color: #fff;
    margin-top: 12px;
    margin-right: 10px;
    border-bottom: 1px solid;
    line-height: 25px;
    letter-spacing: 3px;
}
.personInfo .title td:nth-child(2n-1){
  width: 25%;
    height: 80px;
    text-align: center;
    padding: 0;
    line-height: 80px;
    color: red;
}
.personInfo .title td:nth-child(2n){
  width: 25%;
    height: 80px;
    text-align: center;
    padding: 0;
    line-height: 80px;
    color: red;
}

.personInfo .date td:nth-child(2n-1){
    height: 40px;
    text-align: center;
    padding: 0;
    line-height: 40px;
    color: red;
}
.personInfo .date td:nth-child(2n){
    text-align: center;
    padding: 0;
    height: 40px;
    line-height: 40px;
    color: red;
}
</style>